import { Directive, HostListener, HostBinding, Output, EventEmitter, Input } from '@angular/core';
export class AmdInputDirective {
    constructor() {
        this.isFocussedChange = new EventEmitter();
        this.inputClass = true;
        this.inputFocussedClass = false;
        this._isFocussed = false;
    }
    /**
     * @param {?} isFocussed
     * @return {?}
     */
    set isFocussed(isFocussed) {
        this.setFocus(isFocussed);
    }
    /**
     * @return {?}
     */
    onFocus() {
        this.setFocus(true);
    }
    /**
     * @return {?}
     */
    onBlur() {
        this.setFocus(false);
    }
    /**
     * @param {?} focus
     * @return {?}
     */
    setFocus(focus) {
        this._isFocussed = focus;
        this.inputFocussedClass = focus;
        this.isFocussedChange.emit(focus);
        // this.changeDetectorRef.markForCheck();
    }
}
AmdInputDirective.decorators = [
    { type: Directive, args: [{
                selector: '[amdInput]'
            },] },
];
/**
 * @nocollapse
 */
AmdInputDirective.ctorParameters = () => [];
AmdInputDirective.propDecorators = {
    'isFocussedChange': [{ type: Output },],
    'inputClass': [{ type: HostBinding, args: ['class.amd-input',] },],
    'inputFocussedClass': [{ type: HostBinding, args: ['class.amd-input--focussed',] },],
    'isFocussed': [{ type: Input },],
    'onFocus': [{ type: HostListener, args: ['focus',] },],
    'onBlur': [{ type: HostListener, args: ['blur',] },],
};
function AmdInputDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdInputDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdInputDirective.ctorParameters;
    /** @type {?} */
    AmdInputDirective.propDecorators;
    /** @type {?} */
    AmdInputDirective.prototype.isFocussedChange;
    /** @type {?} */
    AmdInputDirective.prototype.inputClass;
    /** @type {?} */
    AmdInputDirective.prototype.inputFocussedClass;
    /** @type {?} */
    AmdInputDirective.prototype._isFocussed;
}
//# sourceMappingURL=input.directive.js.map
//# sourceMappingURL=input.directive.js.map
